export default __webpack_public_path__ + "static/media/arenPro1.57cde006.jpg";